"use strict";

/**
 * Show popunder Ad instead of source site when user trying to click "Back"
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var stopCookie = 'bbh_stop';
  /** If events were already initialized in previous `onPageLoad` */
  var initialized = false;

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** No stop cookie */ && !FlixUtils.hasCookie(stopCookie)
    /** Not for bots and crawlers */ && !FlixUtils.isCrawler() && !FlixPop.isEnabled()
    // Disable for Chrome temporarily
    && (!(FlixUtils.isChrome() && FlixUtils.isMobile()) || Flix.ads.wild)
    /** Not on TNA organic */
    // && !(Flix.isTna() && Flix.ads.isOrganic())
    /** History API should be available */ && typeof window.history != 'undefined' && typeof window.history.pushState != 'undefined';
  }
  ;

  /**
   * Initialize events here instead of `init()` because we need FlixUtils
   * in `isEnabled()`that  might not be loaded during `init()` call
   */
  function onPageLoad() {
    if (initialized || !isEnabled()) {
      return;
    }
    initialized = true;
    var currentUrl = window.location.href;
    window.history.pushState('/exo1234.html', '_', '/exo1234.html');
    window.history.pushState(currentUrl, 'Flix', currentUrl);
    localStorage.setItem('referrer_url', Flix.referrer || "/"); // store referrer if it's external
    window.addEventListener('popstate', onBack);
    FlixUtils.setCookie(stopCookie, 0, 1 / 8); // set stop cookie
  }
  ;

  /**
   * Main logic
   */
  function onBack() {
    if (document.URL.indexOf("exo1234.html") >= 0) {
      if (isEnabled()) {
        FlixUtils.setCookie(stopCookie, 1, 1);
        var thumb = document.querySelector('.thumb');
        thumb.setAttribute('href', localStorage.getItem('referrer_url') || '/');
        thumb.click();
      } else {
        try {
          window.history.go(-2);
        } catch (z) {}
      }
    }
  }
  ;
})();